import { memo } from 'react';

import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

import { PIE_CHART_HEIGHT } from '../../constants';

export const PieChartLoader = memo(() => {
  return (
    <Stack alignItems="center" direction="row" gap={4} height="100%" justifyContent="center">
      <Skeleton height={PIE_CHART_HEIGHT} variant="circular" width={PIE_CHART_HEIGHT} />
      <Stack>
        {Array.from({ length: 4 })
          .fill(null)
          .map((_, index) => (
            <Skeleton key={index} height={30} variant="text" width={200} />
          ))}
      </Stack>
    </Stack>
  );
});
